import React from "react"
import useGoogleSheets from "use-google-sheets"
import config from "../../../firebaseConfig"
import ReactPlayer from "react-player"
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner"
import {recordEvent} from '../../apis/googleAnalytics'

const BibleEffectVideo = ({ language, version, book, setShowRR }) => {
  const { data, loading, error } = useGoogleSheets({
    apiKey: "AIzaSyAb_P06-faYkzrsHqYvF7us6kBdfyIpY6M",
    sheetId: "1himOygLZtjw6UpS5n2aqSfwULovpEpxeoeGD7mXRnM4",
    sheetsNames: [language],
  })

  if (loading) {
    return (
      <div
        style={{
          position: "relative",
          width: "100%",
          textAlign: "center",
        }}
      >
        <LoadingSpinner />
      </div>
    )
  }

  if (error) {
    return null
  }

  const books = data[0].data
  const selectedBook = books.find(b => b["SVB BookID"] === book)
  const urls = [selectedBook['YouTube URL1']]
  if (selectedBook["YouTube URL2"]) {
    urls.push(selectedBook["YouTube URL2"])
  }
  if (selectedBook["YouTube URL3"]) {
    urls.push(selectedBook["YouTube URL3"])
  }

  if (!urls || !urls[0]) return null

  setShowRR(true)
  return urls
    ? urls.map(url => (
        <div
          style={{
            margin: "10px 0 100px 0",
            display: "flex",
            justifyContent: "center",
          }}
          key={url}
        >
          <ReactPlayer
            url={url}
            controls
            onStart={() =>
              recordEvent("Start Bible Project Video", `${language}-${version}`, book)
            }
          />
        </div>
      ))
    : null
}

export default BibleEffectVideo